export const bundleData: any = {
    ca: [
        // 真实数据
        {
            id: '7779167273114',
            type: 2, //1 时间限定 2 数量限定
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'GLACIER Portable Refrigerator',
            tag: 2,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/1.png',
            mobileImg: '/media/glacier/crowdfunding/h5/1.png',
            include: ['GLACIER Portable Refrigerator x 1', '*Wheels and lever are not included'],
            hasNote: true,
            delivery_date: 'Early May 2023',
            sale: 0,
            count: 50,
            discountPrice: 1049,
            originalPrice: 1399,
            price_suffix: '',
            // sku: 'ZMH200-H-ZMH200BP-B-JP',
            node: 'product-component-1681097205871',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '7780790141082',
            variantId: '43479547609242',
            type: 2,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'GLACIER Portable Refrigerator',
            tag: 4, // 2023-05-06 卖不动、为刺激消费， @陈琨 要求添加
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/1.png',
            mobileImg: '/media/glacier/crowdfunding/h5/1.png',
            include: ['GLACIER Portable Refrigerator x 1', '*Wheels and lever are not included'],
            hasNote: true,
            delivery_date: 'Early May 2023',
            sale: 0,
            count: null,
            countdown: true, // 2023-05-06 卖不动、为刺激消费， @陈琨 要求添加倒计时，以加强紧迫感
            discountPrice: 1299,
            originalPrice: 1399,
            price_suffix: '',
            sku: '7780790141082',
            node: 'product-component-1681185626636',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        {
            id: '7779167305882',
            type: 2, //1 时间限定 2 数量限定
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'GLACIER Portable Refrigerator + GLACIER Plug-in Battery',
            tag: 2,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/2.png',
            mobileImg: '/media/glacier/crowdfunding/h5/2.png',
            include: ['GLACIER Portable Refrigerator x 1', 'GLACIER Plug-in Battery x 1', '*Wheels and lever are not included'],
            hasNote: true,
            delivery_date: 'Mid June 2023',
            sale: 0,
            count: 50,
            discountPrice: 1399,
            originalPrice: 1799,
            price_suffix: '',
            sku: '7779167305882',
            node: 'product-component-1681097175580',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '7780790141082',
            variantId: '43479547510938',
            type: 2,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'GLACIER Portable Refrigerator + GLACIER Plug-in Battery',
            tag: 4, // 2023-05-06 卖不动、为刺激消费， @陈琨 要求添加
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/2.png',
            mobileImg: '/media/glacier/crowdfunding/h5/2.png',
            include: ['GLACIER Portable Refrigerator x 1', 'GLACIER Plug-in Battery x 1', '*Wheels and lever are not included'],
            hasNote: true,
            delivery_date: 'Mid June 2023',
            sale: 0,
            count: null,
            countdown: true, // 2023-05-06 卖不动、为刺激消费， @陈琨 要求添加倒计时，以加强紧迫感
            discountPrice: 1599,
            originalPrice: 1799,
            price_suffix: '',
            sku: '7780790141082',
            node: 'product-component-1681185605661',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        {
            id: '7779167404186',
            type: 2, //1 时间限定 2 数量限定
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'GLACIER Portable Refrigerator  + DELTA Max 2000',
            tag: 2,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/3.png',
            mobileImg: '/media/glacier/crowdfunding/h5/3.png',
            include: ['GLACIER Portable Refrigerator x 1', 'DELTA Max 2000 x 1', '*Wheels and lever are not included'],
            hasNote: true,
            delivery_date: 'Early May 2023',
            sale: 0,
            count: 80,
            discountPrice: 2999,
            originalPrice: 3999,
            price_suffix: '',
            sku: '7779167404186',
            node: 'product-component-1681097112995',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '7780790173850',
            variantId: '43479547773082',
            type: 2,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'GLACIER Portable Refrigerator  + DELTA Max 2000',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/3.png',
            mobileImg: '/media/glacier/crowdfunding/h5/3.png',
            include: ['GLACIER Portable Refrigerator x 1', 'DELTA Max 2000 x 1', '*Wheels and lever are not included'],
            hasNote: true,
            delivery_date: 'Early May 2023',
            sale: 0,
            count: null,
            discountPrice: 3299,
            originalPrice: 3999,
            price_suffix: '',
            sku: '7780790173850',
            node: 'product-component-1681185547471',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        // 又说不上ca了
        // {
        //     id: '7779167338650',
        //     type: 2, //1 时间限定 2 数量限定
        //     stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
        //     off: '',
        //     offTips: '',
        //     name: 'GLACIER Portable Refrigerator + RIVER 2 Pro',
        //     tag: 2,
        //     isEnd: false,
        //     img: '/media/glacier/crowdfunding/pc/4.png',
        //     mobileImg: '/media/glacier/crowdfunding/h5/4.png',
        //     include: ['GLACIER Portable Refrigerator x 1', 'RIVER 2 Pro x 1'],
        //     delivery_date: 'Early May 2023',
        //     sale: 0,
        //     count: 60,
        //     discountPrice: 1699,
        //     originalPrice: 2099,
        //     price_suffix: '',
        //     sku: '7779167338650',
        //     node: 'product-component-1681097149971',
        //     buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        // },
        // {
        //     id: '7780790173850',
        //     variantId: '43479547642010',
        //     type: 2,
        //     stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
        //     off: '',
        //     offTips: '',
        //     name: 'GLACIER Portable Refrigerator  + RIVER 2 Pro',
        //     tag: null,
        //     isEnd: false,
        //     img: '/media/glacier/crowdfunding/pc/4.png',
        //     mobileImg: '/media/glacier/crowdfunding/h5/4.png',
        //     include: ['GLACIER Portable Refrigerator x 1', 'RIVER 2 Pro x 1'],
        //     delivery_date: 'Early May 2023',
        //     sale: 0,
        //     count: null,
        //     discountPrice: 1999,
        //     originalPrice: 2099,
        //     price_suffix: '',
        //     sku: '7780790173850',
        //     node: 'product-component-1681185576112',
        //     buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        // },
    ],
    us: [
        // 真实数据
        // Glacier
        {
            id: '6900906590281',
            type: 2, //1 时间限定 2 数量限定
            stage: 1, // 1 早鸟 2 原价
            off: '',
            offTips: '',
            name: 'GLACIER Portable Refrigerator',
            tag: 2,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/1.png',
            mobileImg: '/media/glacier/crowdfunding/h5/1.png',
            include: ['GLACIER Portable Refrigerator x 1', '*Wheels and lever are not included'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: 100,
            discountPrice: 799,
            originalPrice: 1099,
            price_suffix: '',
            // sku: 'ZMH200-H-ZMH200BP-B-JP',
            node: 'product-component-1681097286785',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '6900974616649',
            variantId: '40518726025289',
            type: 2,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'GLACIER Portable Refrigerator',
            tag: 4, // 2023-05-06 卖不动、为刺激消费， @陈琨 要求添加
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/1.png',
            mobileImg: '/media/glacier/crowdfunding/h5/1.png',
            include: ['GLACIER Portable Refrigerator x 1', '*Wheels and lever are not included'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true, // 2023-05-06 卖不动、为刺激消费， @陈琨 要求添加倒计时，以加强紧迫感
            discountPrice: 849,
            originalPrice: 1099,
            price_suffix: '',
            node: 'product-component-1681185714712',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        // Glacier + Battery
        {
            id: '6900906655817',
            type: 2, //1 时间限定 2 数量限定
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'GLACIER Portable Refrigerator + GLACIER Plug-in Battery',
            tag: 2,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/2.png',
            mobileImg: '/media/glacier/crowdfunding/h5/2.png',
            include: ['GLACIER Portable Refrigerator x 1', 'GLACIER Plug-in Battery x 1', '*Wheels and lever are not included'],
            hasNote: true,
            delivery_date: 'Late June 2023',
            buy_btn: 'Pre-order',
            sale: 0,
            count: 100,
            discountPrice: 999,
            originalPrice: 1399,
            price_suffix: '', // 0512 @陈琨 要求改为预售
            sku: '6900906655817',
            node: 'product-component-1681097268033',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '6900974616649',
            variantId: '40518725926985',
            type: 2,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'GLACIER Portable Refrigerator + GLACIER Plug-in Battery',
            tag: 4, // 2023-05-06 卖不动、为刺激消费， @陈琨 要求添加
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/2.png',
            mobileImg: '/media/glacier/crowdfunding/h5/2.png',
            include: ['GLACIER Portable Refrigerator x 1', 'GLACIER Plug-in Battery x 1', '*Wheels and lever are not included'],
            hasNote: true,
            delivery_date: 'Late June 2023',
            buy_btn: 'Pre-order',
            sale: 0,
            count: null,
            countdown: true, // 2023-05-06 卖不动、为刺激消费， @陈琨 要求添加倒计时，以加强紧迫感
            discountPrice: 1199,
            originalPrice: 1399,
            price_suffix: '',
            sku: '6900974616649',
            node: 'product-component-1681185689444',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        // Glacier + DELTA Max 2000
        // 2023-04-28 => 卖得不好，下架
        // {
        //     id: '6900906721353',
        //     type: 2, //1 时间限定 2 数量限定
        //     stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
        //     off: '',
        //     offTips: '',
        //     name: 'GLACIER Portable Refrigerator  + DELTA Max 2000',
        //     tag: 2,
        //     isEnd: false,
        //     img: '/media/glacier/crowdfunding/pc/3.png',
        //     mobileImg: '/media/glacier/crowdfunding/h5/3.png',
        //     include: ['GLACIER Portable Refrigerator x 1', 'DELTA Max 2000 x 1', '(Wheels and lever are not included) '],
        //     delivery_date: '',
        //     sale: 0,
        //     count: 200,
        //     discountPrice: 2299,
        //     originalPrice: 3199,
        //     price_suffix: '',
        //     sku: '6900906721353',
        //     node: 'product-component-1681097232467',
        //     buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        // },
        // {
        //     id: '6900975075401',
        //     variantId: '40518741491785',
        //     type: 2,
        //     stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
        //     off: '',
        //     offTips: '',
        //     name: 'GLACIER Portable Refrigerator  + DELTA Max 2000',
        //     tag: null,
        //     isEnd: false,
        //     img: '/media/glacier/crowdfunding/pc/3.png',
        //     mobileImg: '/media/glacier/crowdfunding/h5/3.png',
        //     include: ['GLACIER Portable Refrigerator x 1', 'DELTA Max 2000 x 1', '(Wheels and lever are not included) '],
        //     delivery_date: '',
        //     sale: 0,
        //     count: null,
        //     discountPrice: 2499,
        //     originalPrice: 3199,
        //     price_suffix: '',
        //     sku: '6900975075401',
        //     node: 'product-component-1681185644860',
        //     buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        // },

        // Glacier + RIVER 2 Pro
        {
            id: '6900906688585',
            type: 2, //1 时间限定 2 数量限定
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'GLACIER Portable Refrigerator + RIVER 2 Pro',
            tag: 2,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/4.png',
            mobileImg: '/media/glacier/crowdfunding/h5/4.png',
            include: ['GLACIER Portable Refrigerator x 1', 'RIVER 2 Pro x 1', '*Wheels and lever are not included'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: 200,
            discountPrice: 1299,
            originalPrice: 1699,
            price_suffix: '',
            sku: '6900906688585',
            node: 'product-component-1681097251506',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '6900975075401',
            variantId: '40518741262409',
            type: 2,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'GLACIER Portable Refrigerator  + RIVER 2 Pro',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/4.png',
            mobileImg: '/media/glacier/crowdfunding/h5/4.png',
            include: ['GLACIER Portable Refrigerator x 1', 'RIVER 2 Pro x 1', '*Wheels and lever are not included'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            discountPrice: 1499,
            originalPrice: 1699,
            price_suffix: '',
            sku: '6900975075401',
            node: 'product-component-1681185667611',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        // GLACIER Portable Refrigerator + DELTA Pro
        // 2023-04-28 上架 => 替换 GLACIER Portable Refrigerator  + DELTA Max 2000
        {
            id: '6903979901001',
            type: 2, //1 时间限定 2 数量限定
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'GLACIER Portable Refrigerator + DELTA Pro',
            tag: 2,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/5.png',
            mobileImg: '/media/glacier/crowdfunding/h5/5.png',
            include: ['GLACIER Portable Refrigerator x 1', 'DELTA Pro x 1', '*Wheels and lever are not included'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: 200,
            discountPrice: 3999,
            originalPrice: 4799,
            price_suffix: '',
            sku: '6903979901001',
            node: 'product-component-1682585541476',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '6903991271497',
            type: 2,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'GLACIER Portable Refrigerator + DELTA Pro',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/5.png',
            mobileImg: '/media/glacier/crowdfunding/h5/5.png',
            include: ['GLACIER Portable Refrigerator x 1', 'DELTA Pro x 1', '*Wheels and lever are not included'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            discountPrice: 4199,
            originalPrice: 4799,
            price_suffix: '',
            sku: '6903991271497',
            node: 'product-component-1682585691111',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },
    ],
    jp: [
        // 真实数据
        {
            id: '7680679116961',
            variantId: '42969137021089',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '15% OFF',
            offTips: '',
            name: 'GLACIER ポータブル冷蔵庫',
            tag: 2,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/1_jp.png',
            mobileImg: '/media/glacier/crowdfunding/h5/1_jp.png',
            include: [],
            delivery_date: '2023年5月末から順次発送',
            sale: 0,
            count: null,
            discountPrice: 105660,
            originalPrice: 124300,
            price_suffix: '(税込)',
            sku: '42969137021089',
            node: 'product-component-1680601532384',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '7680679116961',
            variantId: '42969137021089',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '10% OFF',
            offTips: '',
            name: 'GLACIER ポータブル冷蔵庫',
            tag: 2,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/1_jp.png',
            mobileImg: '/media/glacier/crowdfunding/h5/1_jp.png',
            include: [],
            delivery_date: '2023年5月24日から順次発送',
            sale: 0,
            count: null,
            discountPrice: 111870,
            originalPrice: 124300,
            price_suffix: '(税込)',
            sku: '42969137021089',
            node: 'product-component-1680601532384',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        {
            id: '7680679116961',
            variantId: '42969137053857',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '20% OFF',
            offTips: '',
            name: 'GLACIER ポータブル冷蔵庫 + GLACIER 専用バッテリーパック',
            tag: 2,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/2_jp.png',
            mobileImg: '/media/glacier/crowdfunding/h5/2_jp.png',
            include: [],
            delivery_date: '2023年5月末から順次発送',
            sale: 0,
            count: null,
            discountPrice: 121880,
            originalPrice: 152350,
            price_suffix: '(税込)',
            sku: '42969137053857',
            node: 'product-component-1680601600170',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '7680679116961',
            variantId: '42969137053857',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '15% OFF',
            offTips: '',
            name: 'GLACIER ポータブル冷蔵庫 + GLACIER 専用バッテリーパック',
            tag: 2,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/2_jp.png',
            mobileImg: '/media/glacier/crowdfunding/h5/2_jp.png',
            include: [],
            delivery_date: '2023年5月24日から順次発送',
            sale: 0,
            count: null,
            discountPrice: 129500,
            originalPrice: 152350,
            price_suffix: '(税込)',
            sku: '42969137053857',
            node: 'product-component-1680601600170',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        {
            id: '7680681902241',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '20% OFF',
            offTips: '',
            name: 'GLACIER ポータブル冷蔵庫 + GLACIER 専用バッテリーパック + 220W両面受光型ソーラーパネル',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/3_jp.png',
            mobileImg: '/media/glacier/crowdfunding/h5/3_jp.png',
            include: [],
            delivery_date: '2023年5月末から順次発送',
            sale: 0,
            count: null,
            discountPrice: 175820,
            originalPrice: 219780,
            price_suffix: '(税込)',
            sku: '42959996977313',
            node: 'product-component-1680601647008',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '7680681902241',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '15% OFF',
            offTips: '',
            name: 'GLACIER ポータブル冷蔵庫 + GLACIER 専用バッテリーパック + 220W両面受光型ソーラーパネル',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/3_jp.png',
            mobileImg: '/media/glacier/crowdfunding/h5/3_jp.png',
            include: [],
            delivery_date: '2023年5月24日から順次発送',
            sale: 0,
            count: null,
            discountPrice: 186810,
            originalPrice: 219780,
            price_suffix: '(税込)',
            sku: '42959996977313',
            node: 'product-component-1680601647008',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        {
            id: '7680689602721',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '30% OFF',
            offTips: '',
            name: 'GLACIER ポータブル冷蔵庫 + DELTA Max 2000',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/4_jp.png',
            mobileImg: '/media/glacier/crowdfunding/h5/4_jp.png',
            include: [],
            delivery_date: '2023年5月末から順次発送',
            sale: 0,
            count: null,
            discountPrice: 248710,
            originalPrice: 355300,
            price_suffix: '(税込)',
            sku: '42960005496993',
            node: 'product-component-1680601676513',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '7680689602721',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '25% OFF', // 0508 @陈琨 要求改价格 https://project.feishu.cn/mz820/story/detail/6790993
            offTips: '',
            name: 'GLACIER ポータブル冷蔵庫 + DELTA Max 2000',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/4_jp.png',
            mobileImg: '/media/glacier/crowdfunding/h5/4_jp.png',
            include: [],
            delivery_date: '2023年5月24日から順次発送',
            sale: 0,
            count: null,
            discountPrice: 266480, // 0508 @陈琨 要求改价格 https://project.feishu.cn/mz820/story/detail/6790993
            originalPrice: 355300,
            price_suffix: '(税込)',
            sku: '42960005496993',
            node: 'product-component-1680601676513',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        {
            id: '7680690978977',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '30% OFF',
            offTips: '',
            name: 'GLACIER ポータブル冷蔵庫 + DELTA Max 2000 + 220W両面受光型ソーラーパネル',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/5_jp.png',
            mobileImg: '/media/glacier/crowdfunding/h5/5_jp.png',
            include: [],
            delivery_date: '2023年5月末から順次発送',
            sale: 0,
            count: null,
            discountPrice: 295680,
            originalPrice: 422400,
            price_suffix: '(税込)',
            sku: '42960007037089',
            node: 'product-component-1680601711827',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '7680690978977',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '25% OFF', // 0508 @陈琨 要求改价格 https://project.feishu.cn/mz820/story/detail/6790993
            offTips: '',
            name: 'GLACIER ポータブル冷蔵庫 + DELTA Max 2000 + 220W両面受光型ソーラーパネル',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/5_jp.png',
            mobileImg: '/media/glacier/crowdfunding/h5/5_jp.png',
            include: [],
            delivery_date: '2023年5月24日から順次発送',
            sale: 0,
            count: null,
            discountPrice: 316800, // 0508 @陈琨 要求改价格 https://project.feishu.cn/mz820/story/detail/6790993
            originalPrice: 422400,
            price_suffix: '(税込)',
            sku: '42960007037089',
            node: 'product-component-1680601711827',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        {
            id: '7694819492001',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER専用キャスター・ハンドル',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/6_jp.png',
            mobileImg: '/media/glacier/crowdfunding/h5/6_jp.png',
            include: [],
            delivery_date: '',
            sale: 0,
            count: null,
            discountPrice: 14300,
            originalPrice: 14300,
            price_suffix: '(税込)',
            sku: '42960007037089',
            node: 'product-component-1682566580772',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '7694819492001',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER専用キャスター・ハンドル',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/6_jp.png',
            mobileImg: '/media/glacier/crowdfunding/h5/6_jp.png',
            include: [],
            delivery_date: '',
            sale: 0,
            count: null,
            discountPrice: 14300,
            originalPrice: 14300,
            price_suffix: '(税込)',
            sku: '42960007037089',
            node: 'product-component-1682566580772',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },
    ],
    // 0616 新增欧洲六站早鸟数据 @陈琨 两个阶段：第一阶段夏季促销 summer promotion 第二阶段 常规售卖
    eu: [
        // Glacier
        {
            id: '8364025938263',
            variantId: '46496798769495',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER Portable Refrigerator',
            tag: 'Limeted Offer',
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/1_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/1_eu.png',
            include: ['GLACIER Portable Refrigerator x 1', '* Wheels and lever are not included'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 999,
            originalPrice: 1199,
            price_suffix: '',
            sku: '46496798769495',
            node: 'product-component-1686569398727',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '8364025938263',
            variantId: '46496798769495',
            type: 1, //1 时间限定 2 数量限定
            stage: 2, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER Portable Refrigerator',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/1_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/1_eu.png',
            include: ['GLACIER Portable Refrigerator x 1', '* Wheels and lever are not included'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 999,
            originalPrice: 1199,
            price_suffix: '',
            sku: '46496798769495',
            node: 'product-component-1686569398727',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },

        // GLACIER + Plug-in Battery
        {
            id: '8364025938263',
            variantId: '46493270475095',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER + Plug-in Battery',
            tag: 'Limeted Offer',
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/2_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/2_eu.png',
            include: ['GLACIER Portable Refrigerator x 1', 'GLACIER Plug-in Battery x 1', '* Wheels and lever are not included'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 1199,
            originalPrice: 1498,
            price_suffix: '',
            sku: '46493270475095',
            node: 'product-component-1686624824177',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '8364025938263',
            variantId: '46493270475095',
            type: 1, //1 时间限定 2 数量限定
            stage: 2, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER + Plug-in Battery',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/2_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/2_eu.png',
            include: ['GLACIER Portable Refrigerator x 1', 'GLACIER Plug-in Battery x 1', '* Wheels and lever are not included'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 1199,
            originalPrice: 1399,
            price_suffix: '',
            sku: '46491286536535',
            node: 'product-component-1686624824177',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },

        // GLACIER + RIVER 2 Pro
        {
            id: '8365077791063',
            variantId: '46491286536535',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER + RIVER 2 Pro',
            tag: 'Limeted Offer',
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/3_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/3_eu.png',
            include: ['GLACIER Portable Refrigerator x 1', 'RIVER 2 Pro Portable Power Station x 1', '* Wheels and lever are not included'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 1698,
            originalPrice: 1998,
            price_suffix: '',
            sku: '46491286536535',
            node: 'product-component-1686624868842',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '8365077791063',
            variantId: '46491286536535',
            type: 1, //1 时间限定 2 数量限定
            stage: 2, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER + RIVER 2 Pro',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/3_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/3_eu.png',
            include: ['GLACIER Portable Refrigerator x 1', 'RIVER 2 Pro Portable Power Station x 1', '* Wheels and lever are not included'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 1798,
            originalPrice: 1998,
            price_suffix: '',
            sku: '46491286536535',
            node: 'product-component-1686624868842',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },

        // GLACIER + DELTA Max
        {
            id: '8369178345815',
            variantId: '46496803684695',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER + DELTA Max',
            tag: 'Limeted Offer',
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/4_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/4_eu.png',
            include: ['GLACIER Portable Refrigerator x 1', 'DELTA Max 2000 Portable Power Station x 1', '* Wheels and lever are not included'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 2698,
            originalPrice: 3498,
            price_suffix: '',
            sku: '46496803684695',
            node: 'product-component-1686624910693',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '8369178345815',
            variantId: '46496803684695',
            type: 1, //1 时间限定 2 数量限定
            stage: 2, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER + DELTA Max',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/4_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/4_eu.png',
            include: ['GLACIER Portable Refrigerator x 1', 'DELTA Max 2000 Portable Power Station x 1', '* Wheels and lever are not included'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            // countdown: true,
            discountPrice: 2898,
            originalPrice: 3098,
            price_suffix: '',
            sku: '46496803684695',
            node: 'product-component-1686624910693',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        // GLACIER + DELTA 2 Max => 图片待替换
        // {
        //     id: '8432349839703',
        //     variantId: '46770139005271',
        //     type: 1, //1 时间限定 2 数量限定
        //     stage: 2, // 1 早鸟 2 原价
        //     ignore: true, // 无限库存
        //     off: '',
        //     offTips: '',
        //     name: 'GLACIER + DELTA 2 Max',
        //     tag: null,
        //     isEnd: false,
        //     img: '/media/glacier/crowdfunding/pc/5_eu.png',
        //     mobileImg: '/media/glacier/crowdfunding/h5/5_eu.png',
        //     include: ['GLACIER Portable Refrigerator x 1', 'DELTA 2 Max Portable Power Station x 1', '* Wheels and lever are not included'],
        //     hasNote: true,
        //     delivery_date: '',
        //     sale: 0,
        //     count: null,
        //     countdown: false,
        //     discountPrice: 3298,
        //     originalPrice: 3298,
        //     price_suffix: '',
        //     sku: '46770139005271',
        //     node: 'product-component-1686627389537',
        //     buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        // },
    ],
    uk: [
        // Glacier
        {
            id: '8376008474963',
            variantId: '46526037360979',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER Portable Refrigerator',
            tag: 'Limeted Offer',
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/1_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/1_eu.png',
            include: ['GLACIER Portable Refrigerator x 1', '* Wheels and lever are not included'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 849,
            originalPrice: 1049,
            price_suffix: '',
            sku: '46526037360979',
            node: 'product-component-1686624971947',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '8376008474963',
            variantId: '46526037360979',
            type: 1, //1 时间限定 2 数量限定
            stage: 2, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER Portable Refrigerator',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/1_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/1_eu.png',
            include: ['GLACIER Portable Refrigerator x 1', '* Wheels and lever are not included'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 849,
            originalPrice: 1049,
            price_suffix: '',
            sku: '46526037360979',
            node: 'product-component-1686624971947',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },

        // GLACIER + Plug-in Battery
        {
            id: '8376008474963',
            variantId: '46526037393747',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER + Plug-in Battery',
            tag: 'Limeted Offer',
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/2_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/2_eu.png',
            include: ['GLACIER Portable Refrigerator x 1', 'GLACIER Plug-in Battery x 1', '* Wheels and lever are not included'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 1049,
            originalPrice: 1348,
            price_suffix: '',
            sku: '46526037393747',
            node: 'product-component-1686624989303',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '8376008474963',
            variantId: '46526037393747',
            type: 1, //1 时间限定 2 数量限定
            stage: 2, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER + Plug-in Battery',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/2_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/2_eu.png',
            include: ['GLACIER Portable Refrigerator x 1', 'GLACIER Plug-in Battery x 1', '* Wheels and lever are not included'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 1049,
            originalPrice: 1249,
            price_suffix: '',
            sku: '46526037393747',
            node: 'product-component-1686624989303',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },

        // GLACIER + RIVER 2 Pro
        {
            id: '8375887528275',
            variantId: '46525837869395',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER + RIVER 2 Pro',
            tag: 'Limeted Offer',
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/3_uk.png',
            mobileImg: '/media/glacier/crowdfunding/h5/3_uk.png',
            include: ['GLACIER Portable Refrigerator x 1', 'RIVER 2 Pro Portable Power Station x 1', '* Wheels and lever are not included'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 1498,
            originalPrice: 1798,
            price_suffix: '',
            sku: '46525837869395',
            node: 'product-component-1686625011509',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '8375887528275',
            variantId: '46525837869395',
            type: 1, //1 时间限定 2 数量限定
            stage: 2, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER + RIVER 2 Pro',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/3_uk.png',
            mobileImg: '/media/glacier/crowdfunding/h5/3_uk.png',
            include: ['GLACIER Portable Refrigerator x 1', 'RIVER 2 Pro Portable Power Station x 1', '* Wheels and lever are not included'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 1598,
            originalPrice: 1798,
            price_suffix: '',
            sku: '46525837869395',
            node: 'product-component-1686625011509',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },

        // GLACIER + DELTA Max
        {
            id: '8375906402643',
            variantId: '46525853073747',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER + DELTA Max',
            tag: 'Limeted Offer',
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/4_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/4_eu.png',
            include: ['GLACIER Portable Refrigerator x 1', 'DELTA Max 2000 Portable Power Station x 1', '* Wheels and lever are not included'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 2348,
            originalPrice: 3048,
            price_suffix: '',
            sku: '46525853073747',
            node: 'product-component-1686624910693',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '8375906402643',
            variantId: '46525853073747',
            type: 1, //1 时间限定 2 数量限定
            stage: 2, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER + DELTA Max',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/4_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/4_eu.png',
            include: ['GLACIER Portable Refrigerator x 1', 'DELTA Max 2000 Portable Power Station x 1', '* Wheels and lever are not included'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            // countdown: true,
            discountPrice: 2548,
            originalPrice: 2748,
            price_suffix: '',
            sku: '46525853073747',
            node: 'product-component-1686624910693',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        // GLACIER + DELTA 2 Max => 图片待替换
        // {
        //     id: '8423178764627',
        //     variantId: '46667395596627',
        //     type: 1, //1 时间限定 2 数量限定
        //     stage: 2, // 1 早鸟 2 原价
        //     ignore: true, // 无限库存
        //     off: '',
        //     offTips: '',
        //     name: 'GLACIER + DELTA 2 Max',
        //     tag: null,
        //     isEnd: false,
        //     img: '/media/glacier/crowdfunding/pc/5_eu.png',
        //     mobileImg: '/media/glacier/crowdfunding/h5/5_eu.png',
        //     include: ['GLACIER Portable Refrigerator x 1', 'DELTA 2 Max Portable Power Station x 1', '* Wheels and lever are not included'],
        //     hasNote: true,
        //     delivery_date: '',
        //     sale: 0,
        //     count: null,
        //     countdown: false,
        //     discountPrice: 3148,
        //     originalPrice: 3148,
        //     price_suffix: '',
        //     sku: '46667395596627',
        //     node: 'product-component-1686625085216',
        //     buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        // },
    ],
    de: [
        // Glacier
        {
            id: '8376354472271',
            variantId: '46538133733711',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER Tragbarer Kühlschrank',
            tag: 'Begrenztes Angebot',
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/1_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/1_eu.png',
            include: ['GLACIER Tragbarer Kühlschrank x 1', '* Laufrollen und Griff sind nicht enthalten'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 999,
            originalPrice: 1199,
            price_suffix: '',
            sku: '46538133733711',
            node: 'product-component-1686625170273',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '8376354472271',
            variantId: '46538133733711',
            type: 1, //1 时间限定 2 数量限定
            stage: 2, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER Tragbarer Kühlschrank',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/1_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/1_eu.png',
            include: ['GLACIER Tragbarer Kühlschrank x 1', '* Laufrollen und Griff sind nicht enthalten'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 999,
            originalPrice: 1199,
            price_suffix: '',
            sku: '46538133733711',
            node: 'product-component-1686625170273',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },

        // GLACIER + Plug-in Battery
        {
            id: '8376354472271',
            variantId: '46538133635407',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER + Zusatzbatterie',
            tag: 'Begrenztes Angebot',
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/2_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/2_eu.png',
            include: ['GLACIER Tragbarer Kühlschrank x 1', 'GLACIER Zusatzbatterie x 1', '* Laufrollen und Griff sind nicht enthalten'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 1199,
            originalPrice: 1498,
            price_suffix: '',
            sku: '46538133635407',
            node: 'product-component-1686625190165',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '8376354472271',
            variantId: '46538133635407',
            type: 1, //1 时间限定 2 数量限定
            stage: 2, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER + Zusatzbatterie',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/2_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/2_eu.png',
            include: ['GLACIER Tragbarer Kühlschrank x 1', 'GLACIER Zusatzbatterie x 1', '* Laufrollen und Griff sind nicht enthalten'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 1199,
            originalPrice: 1399,
            price_suffix: '',
            sku: '46538133635407',
            node: 'product-component-1686625190165',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },

        // GLACIER + RIVER 2 Pro
        {
            id: '8378078593359',
            variantId: '46543532556623',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER + RIVER 2 Pro',
            tag: 'Begrenztes Angebot',
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/3_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/3_eu.png',
            include: ['GLACIER Tragbarer Kühlschrank x 1', 'RIVER 2 Pro Tragbare Powerstation x 1', '* Laufrollen und Griff sind nicht enthalten'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 1698,
            originalPrice: 1998,
            price_suffix: '',
            sku: '46543532556623',
            node: 'product-component-1686625212239',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '8378078593359',
            variantId: '46543532556623',
            type: 1, //1 时间限定 2 数量限定
            stage: 2, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER + RIVER 2 Pro',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/3_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/3_eu.png',
            include: ['GLACIER Tragbarer Kühlschrank x 1', 'RIVER 2 Pro Tragbare Powerstation x 1', '* Laufrollen und Griff sind nicht enthalten'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 1798,
            originalPrice: 1998,
            price_suffix: '',
            sku: '46543532556623',
            node: 'product-component-1686625212239',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },

        // GLACIER + DELTA Max
        {
            id: '8479717654863',
            variantId: '46557798269263',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER + DELTA Max',
            tag: 'Begrenztes Angebot',
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/4_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/4_eu.png',
            include: ['GLACIER Tragbarer Kühlschrank x 1', 'DELTA Max 2000 Tragbare Powerstation x 1', '* Laufrollen und Griff sind nicht enthalten'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 2698,
            originalPrice: 3498,
            price_suffix: '',
            sku: '46557798269263',
            node: 'product-component-1686625237137',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '8479717654863',
            variantId: '46557798269263',
            type: 1, //1 时间限定 2 数量限定
            stage: 2, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER + DELTA Max',
            tag: 'Begrenztes Angebot',
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/4_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/4_eu.png',
            include: ['GLACIER Tragbarer Kühlschrank x 1', 'DELTA Max 2000 Tragbare Powerstation x 1', '* Laufrollen und Griff sind nicht enthalten'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            // countdown: true,
            discountPrice: 2898,
            originalPrice: 3098,
            price_suffix: '',
            sku: '46557798269263',
            node: 'product-component-1686625237137',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        // GLACIER + DELTA 2 Max => 图片待替换
        // {
        //     id: '8524943327567',
        //     variantId: '46725507219791',
        //     type: 1, //1 时间限定 2 数量限定
        //     stage: 2, // 1 早鸟 2 原价
        //     ignore: true, // 无限库存
        //     off: '',
        //     offTips: '',
        //     name: 'GLACIER + DELTA 2 Max',
        //     tag: null,
        //     isEnd: false,
        //     img: '/media/glacier/crowdfunding/pc/5_eu.png',
        //     mobileImg: '/media/glacier/crowdfunding/h5/5_eu.png',
        //     include: ['GLACIER Tragbarer Kühlschrank x 1', 'DELTA 2 Max Tragbare Powerstation x 1', '* Laufrollen und Griff sind nicht enthalten'],
        //     hasNote: true,
        //     delivery_date: '',
        //     sale: 0,
        //     count: null,
        //     countdown: false,
        //     discountPrice: 3298,
        //     originalPrice: 3298,
        //     price_suffix: '',
        //     sku: '46725507219791',
        //     node: 'product-component-1686625267634',
        //     buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        // },
    ],
    fr: [
        // Glacier
        {
            id: '8370479890779',
            variantId: '46505478881627',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'Réfrigérateur portable GLACIER',
            tag: 'Offre limitée',
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/1_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/1_eu.png',
            include: ['Réfrigérateur portable GLACIER x 1', '* Les roues et le levier ne sont pas inclus'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 999,
            originalPrice: 1199,
            price_suffix: '',
            sku: '46505478881627',
            node: 'product-component-1686626936502',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '8370479890779',
            variantId: '46505478881627',
            type: 1, //1 时间限定 2 数量限定
            stage: 2, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'Réfrigérateur portable GLACIER',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/1_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/1_eu.png',
            include: ['Réfrigérateur portable GLACIER x 1', '* Les roues et le levier ne sont pas inclus'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 999,
            originalPrice: 1199,
            price_suffix: '',
            sku: '46505478881627',
            node: 'product-component-1686626936502',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },

        // GLACIER + Plug-in Battery
        {
            id: '8370479890779',
            variantId: '46505478783323',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER + batterie supplémentaire',
            tag: 'Offre limitée',
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/2_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/2_eu.png',
            include: ['Réfrigérateur portable GLACIER x 1', 'Batterie supplémentaire pour GLACIER x 1', '* Les roues et le levier ne sont pas inclus'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 1199,
            originalPrice: 1498,
            price_suffix: '',
            sku: '46505478783323',
            node: 'product-component-1686626952685',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '8370479890779',
            variantId: '46505478783323',
            type: 1, //1 时间限定 2 数量限定
            stage: 2, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER + batterie supplémentaire',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/2_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/2_eu.png',
            include: ['Réfrigérateur portable GLACIER x 1', 'Batterie supplémentaire pour GLACIER x 1', '* Les roues et le levier ne sont pas inclus'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 1199,
            originalPrice: 1399,
            price_suffix: '',
            sku: '46505478783323',
            node: 'product-component-1686626952685',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },

        // GLACIER + RIVER 2 Pro
        {
            id: '8370479661403',
            variantId: '46505478521179',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER + RIVER 2 Pro',
            tag: 'Offre limitée',
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/3_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/3_eu.png',
            include: ['Réfrigérateur portable GLACIER x 1', 'Station électrique portable RIVER 2 Pro x 1', '* Les roues et le levier ne sont pas inclus'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 1698,
            originalPrice: 1998,
            price_suffix: '',
            sku: '46505478521179',
            node: 'product-component-1686626996093',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '8370479661403',
            variantId: '46505478521179',
            type: 1, //1 时间限定 2 数量限定
            stage: 2, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER + RIVER 2 Pro',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/3_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/3_eu.png',
            include: ['Réfrigérateur portable GLACIER x 1', 'Station électrique portable RIVER 2 Pro x 1', '* Les roues et le levier ne sont pas inclus'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 1798,
            originalPrice: 1998,
            price_suffix: '',
            sku: '46505478521179',
            node: 'product-component-1686626996093',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },

        // GLACIER + DELTA Max
        {
            id: '8392939143515',
            variantId: '46689472119131',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER + DELTA Max',
            tag: 'Offre limitée',
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/4_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/4_eu.png',
            include: ['Réfrigérateur portable GLACIER x 1', 'Station électrique portable DELTA Max 2000 x 1', '* Les roues et le levier ne sont pas inclus'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 2698,
            originalPrice: 3498,
            price_suffix: '',
            sku: '46689472119131',
            node: 'product-component-1686627016281',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '8392939143515',
            variantId: '46689472119131',
            type: 1, //1 时间限定 2 数量限定
            stage: 2, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER + DELTA Max',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/4_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/4_eu.png',
            include: ['Réfrigérateur portable GLACIER x 1', 'Station électrique portable DELTA Max 2000 x 1', '* Les roues et le levier ne sont pas inclus'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            // countdown: true,
            discountPrice: 2898,
            originalPrice: 3098,
            price_suffix: '',
            sku: '46689472119131',
            node: 'product-component-1686627016281',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        // GLACIER + DELTA 2 Max => 图片待替换
        // {
        //     id: '8443703230811',
        //     variantId: '46778498842971',
        //     type: 1, //1 时间限定 2 数量限定
        //     stage: 2, // 1 早鸟 2 原价
        //     ignore: true, // 无限库存
        //     off: '',
        //     offTips: '',
        //     name: 'GLACIER + DELTA 2 Max',
        //     tag: null,
        //     isEnd: false,
        //     img: '/media/glacier/crowdfunding/pc/5_eu.png',
        //     mobileImg: '/media/glacier/crowdfunding/h5/5_eu.png',
        //     include: ['Réfrigérateur portable GLACIER x 1', 'Station électrique portable DELTA 2 Max x 1', '* Les roues et le levier ne sont pas inclus'],
        //     hasNote: true,
        //     delivery_date: '',
        //     sale: 0,
        //     count: null,
        //     countdown: false,
        //     discountPrice: 3298,
        //     originalPrice: 3298,
        //     price_suffix: '',
        //     sku: '46778498842971',
        //     node: 'product-component-1686627064236',
        //     buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        // },
    ],
    it: [
        // Glacier
        {
            id: '8368685089117',
            variantId: '46532250435933',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'Frigorifero portatile GLACIER',
            tag: 'Offerta limitata',
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/1_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/1_eu.png',
            include: ['Frigorifero portatile GLACIER x 1', '* Le ruote e la leva non sono incluse'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 999,
            originalPrice: 1199,
            price_suffix: '',
            sku: '46532250435933',
            node: 'product-component-1686627166678',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '8368685089117',
            variantId: '46532250435933',
            type: 1, //1 时间限定 2 数量限定
            stage: 2, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'Frigorifero portatile GLACIER',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/1_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/1_eu.png',
            include: ['Frigorifero portatile GLACIER x 1', '* Le ruote e la leva non sono incluse'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 999,
            originalPrice: 1199,
            price_suffix: '',
            sku: '46532250435933',
            node: 'product-component-1686627166678',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },

        // GLACIER + Plug-in Battery
        {
            id: '8368685089117',
            variantId: '46532250337629',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER + batteria supplementare',
            tag: 'Offerta limitata',
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/2_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/2_eu.png',
            include: ['Frigorifero portatile GLACIER x 1', 'Batteria aggiuntiva GLACIER x 1', '* Le ruote e la leva non sono incluse'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 1199,
            originalPrice: 1498,
            price_suffix: '',
            sku: '46532250337629',
            node: 'product-component-1686627179377',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '8368685089117',
            variantId: '46532250337629',
            type: 1, //1 时间限定 2 数量限定
            stage: 2, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER + batteria supplementare',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/2_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/2_eu.png',
            include: ['Frigorifero portatile GLACIER x 1', 'Batteria aggiuntiva GLACIER x 1', '* Le ruote e la leva non sono incluse'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 1199,
            originalPrice: 1399,
            price_suffix: '',
            sku: '46532250337629',
            node: 'product-component-1686627179377',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },

        // GLACIER + RIVER 2 Pro
        {
            id: '8369412899165',
            variantId: '48061018636637',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER + RIVER 2 Pro',
            tag: 'Offerta limitata',
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/3_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/3_eu.png',
            include: ['Frigorifero portatile GLACIER x 1', 'Power Station Portatile RIVER 2 Pro x 1', '* Le ruote e la leva non sono incluse'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 1698,
            originalPrice: 1998,
            price_suffix: '',
            sku: '46535522451805',
            node: 'product-component-1686627202433',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '8369412899165',
            variantId: '48061018636637',
            type: 1, //1 时间限定 2 数量限定
            stage: 2, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER + RIVER 2 Pro',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/3_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/3_eu.png',
            include: ['Frigorifero portatile GLACIER x 1', 'Power Station Portatile RIVER 2 Pro x 1', '* Le ruote e la leva non sono incluse'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 1798,
            originalPrice: 1998,
            price_suffix: '',
            sku: '46535522451805',
            node: 'product-component-1686627202433',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },

        // GLACIER + DELTA Max
        {
            id: '8383198527837',
            variantId: '46558448386397',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER + DELTA Max',
            tag: 'Offerta limitata',
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/4_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/4_eu.png',
            include: ['Frigorifero portatile GLACIER x 1', 'Power Station Portatile DELTA Max 2000 x 1', '* Le ruote e la leva non sono incluse'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 2698,
            originalPrice: 3498,
            price_suffix: '',
            sku: '46558448386397',
            node: 'product-component-1686627223391',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '8383198527837',
            variantId: '46558448386397',
            type: 1, //1 时间限定 2 数量限定
            stage: 2, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER + DELTA Max',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/4_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/4_eu.png',
            include: ['Frigorifero portatile GLACIER x 1', 'Power Station Portatile DELTA Max 2000 x 1', '* Le ruote e la leva non sono incluse'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            // countdown: true,
            discountPrice: 2898,
            originalPrice: 3098,
            price_suffix: '',
            sku: '46558448386397',
            node: 'product-component-1686627223391',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        // GLACIER + DELTA 2 Max => 图片待替换
        // {
        //     id: '8425527705949',
        //     variantId: '46879290491229',
        //     type: 1, //1 时间限定 2 数量限定
        //     stage: 2, // 1 早鸟 2 原价
        //     ignore: true, // 无限库存
        //     off: '',
        //     offTips: '',
        //     name: 'GLACIER + DELTA 2 Max',
        //     tag: null,
        //     isEnd: false,
        //     img: '/media/glacier/crowdfunding/pc/5_eu.png',
        //     mobileImg: '/media/glacier/crowdfunding/h5/5_eu.png',
        //     include: ['Frigorifero portatile GLACIER x 1', 'Power Station Portatile DELTA 2 Max x 1', '* Le ruote e la leva non sono incluse'],
        //     hasNote: true,
        //     delivery_date: '',
        //     sale: 0,
        //     count: null,
        //     countdown: false,
        //     discountPrice: 3298,
        //     originalPrice: 3298,
        //     price_suffix: '',
        //     sku: '46879290491229',
        //     node: 'product-component-1686627243573',
        //     buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        // },
    ],
    es: [
        // Glacier
        {
            id: '8370476974427',
            variantId: '46505471213915',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'Frigorífico portátil GLACIER',
            tag: 'Oferta limitada',
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/1_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/1_eu.png',
            include: ['Frigorífico portátil GLACIER x 1', '* Ruedas y palanca no incluidas'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 999,
            originalPrice: 1199,
            price_suffix: '',
            sku: '46496798769495',
            node: 'product-component-1686627283522',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '8370476974427',
            variantId: '46505471213915',
            type: 1, //1 时间限定 2 数量限定
            stage: 2, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'Frigorífico portátil GLACIER',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/1_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/1_eu.png',
            include: ['Frigorífico portátil GLACIER x 1', '* Ruedas y palanca no incluidas'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 999,
            originalPrice: 1199,
            price_suffix: '',
            sku: '46496798769495',
            node: 'product-component-1686627283522',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },

        // GLACIER + Plug-in Battery
        {
            id: '8370476974427',
            variantId: '46505471115611',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER  + batería adicional',
            tag: 'Oferta limitada',
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/2_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/2_eu.png',
            include: ['Frigorífico portátil GLACIER x 1', 'Batería adicional GLACIER x 1', '* Ruedas y palanca no incluidas'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 1199,
            originalPrice: 1498,
            price_suffix: '',
            sku: '46505471115611',
            node: 'product-component-1686627298508',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '8370476974427',
            variantId: '46505471115611',
            type: 1, //1 时间限定 2 数量限定
            stage: 2, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER  + batería adicional',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/2_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/2_eu.png',
            include: ['Frigorífico portátil GLACIER x 1', 'Batería adicional GLACIER x 1', '* Ruedas y palanca no incluidas'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 1199,
            originalPrice: 1399,
            price_suffix: '',
            sku: '46505471115611',
            node: 'product-component-1686627298508',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },

        // GLACIER + RIVER 2 Pro
        {
            id: '8371228836187',
            variantId: '46508043207003',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER + RIVER 2 Pro',
            tag: 'Oferta limitada',
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/3_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/3_eu.png',
            include: ['Frigorífico portátil GLACIER x 1', 'Estación de Energía Portátil RIVER 2 Pro x 1', '* Ruedas y palanca no incluidas'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 1698,
            originalPrice: 1998,
            price_suffix: '',
            sku: '46508043207003',
            node: 'product-component-1686627318128',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '8371228836187',
            variantId: '46508043207003',
            type: 1, //1 时间限定 2 数量限定
            stage: 2, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER + RIVER 2 Pro',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/3_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/3_eu.png',
            include: ['Frigorífico portátil GLACIER x 1', 'Estación de Energía Portátil RIVER 2 Pro x 1', '* Ruedas y palanca no incluidas'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 1798,
            originalPrice: 1998,
            price_suffix: '',
            sku: '46508043207003',
            node: 'product-component-1686627318128',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },

        // GLACIER + DELTA Max
        {
            id: '8392991605083',
            variantId: '46689529987419',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER + DELTA Max',
            tag: 'Oferta limitada',
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/4_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/4_eu.png',
            include: ['Frigorífico portátil GLACIER x 1', 'Estación de Energía Portátil DELTA Max 2000 x 1', '* Ruedas y palanca no incluidas'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 2698,
            originalPrice: 3498,
            price_suffix: '',
            sku: '46689529987419',
            node: 'product-component-1686627338518',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '8392991605083',
            variantId: '46689529987419',
            type: 1, //1 时间限定 2 数量限定
            stage: 2, // 1 早鸟 2 原价
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'GLACIER + DELTA Max',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/4_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/4_eu.png',
            include: ['Frigorífico portátil GLACIER x 1', 'Estación de Energía Portátil DELTA Max 2000 x 1', '* Ruedas y palanca no incluidas'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            // countdown: true,
            discountPrice: 2898,
            originalPrice: 3098,
            price_suffix: '',
            sku: '46689529987419',
            node: 'product-component-1686627338518',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        // GLACIER + DELTA 2 Max => 图片待替换
        // {
        //     id: '8446401216859',
        //     variantId: '46784663421275',
        //     type: 1, //1 时间限定 2 数量限定
        //     stage: 2, // 1 早鸟 2 原价
        //     ignore: true, // 无限库存
        //     off: '',
        //     offTips: '',
        //     name: 'GLACIER + DELTA 2 Max',
        //     tag: null,
        //     isEnd: false,
        //     img: '/media/glacier/crowdfunding/pc/4_eu.png',
        //     mobileImg: '/media/glacier/crowdfunding/h5/4_eu.png',
        //     include: ['Frigorífico portátil GLACIER x 1', 'Estación de Energía Portátil DELTA 2 Max x 1', '* Ruedas y palanca no incluidas'],
        //     hasNote: true,
        //     delivery_date: '',
        //     sale: 0,
        //     count: null,
        //     countdown: false,
        //     discountPrice: 3298,
        //     originalPrice: 3298,
        //     price_suffix: '',
        //     sku: '46784663421275',
        //     node: 'product-component-1686627363590',
        //     buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        // },
    ],
    ph: [
        // Glacier
        {
            id: '9570034614582',
            variantId: '51171218784566',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 早鸟 2 原价
            ignore: false, // 无限库存
            needSlodout: true,
            off: '',
            offTips: '',
            name: 'GLACIER Portable Refrigerator',
            tag: 'Limeted Offer',
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/1_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/1_eu.png',
            include: ['GLACIER Portable Refrigerator x 1', '* Wheels and lever are not included'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,

            price_suffix: '',
            sku: '51171218784566',
            node: 'product-component-1686569398727',
        },
        {
            id: '9570034614582',
            variantId: '51171218784566',
            type: 1, //1 时间限定 2 数量限定
            stage: 2, // 1 早鸟 2 原价
            ignore: false, // 无限库存
            needSlodout: true,
            off: '',
            offTips: '',
            name: 'GLACIER Portable Refrigerator',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/1_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/1_eu.png',
            include: ['GLACIER Portable Refrigerator x 1', '* Wheels and lever are not included'],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            price_suffix: '',
            sku: '51171218784566',
            node: 'product-component-1686569398727',
        },

        // GLACIER + Plug-in Battery + Detachable Wheels and Lever
        {
            id: '9570034614582',
            variantId: '49554434621750',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 早鸟 2 原价
            ignore: false, // 无限库存
            needSlodout: true,
            off: '',
            offTips: '',
            name: 'GLACIER + Plug-in Battery + Detachable Wheels and Lever',
            tag: 'Limeted Offer',
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/2_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/2_eu.png',
            include: ['GLACIER Portable Refrigerator x 1', 'GLACIER Plug-in Battery x 1', 'Detachable Wheels and Lever x 1', ''],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            price_suffix: '',
            sku: '49554434621750',
            node: 'product-component-1686624824177',
        },
        {
            id: '9570034614582',
            variantId: '49554434621750',
            type: 1, //1 时间限定 2 数量限定
            stage: 2, // 1 早鸟 2 原价
            ignore: false, // 无限库存
            needSlodout: true,
            off: '',
            offTips: '',
            name: 'GLACIER + Plug-in Battery + Detachable Wheels and Lever',
            tag: null,
            isEnd: false,
            img: '/media/glacier/crowdfunding/pc/2_eu.png',
            mobileImg: '/media/glacier/crowdfunding/h5/2_eu.png',
            include: ['GLACIER Portable Refrigerator x 1', 'GLACIER Plug-in Battery x 1', 'Detachable Wheels and Lever x 1', ''],
            hasNote: true,
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            price_suffix: '',
            sku: '49554434621750',
            node: 'product-component-1686624824177',
        },
    ],
};
